/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import s from './productRecommendations.module.css';
import { productRecommendationsService, retailerSettingsService } from '../../services';
import { attachProductRecListeners } from './helper';

export const ProductRecommendations = () => {
  const [recommendationsUrl, setRecommendationsUrl] = useState(
    productRecommendationsService.getRecommendationsUrl(),
  );

  const [showRecommendations, setShowRecommendations] = useState(false);

  const handleChange = (value) => {
    setShowRecommendations(value);
  };

  useEffect(() => {
    const resetRecommendations = typeof showRecommendations !== 'object' && showRecommendations;

    if (resetRecommendations) {
      setRecommendationsUrl(
        `${productRecommendationsService.getRecommendationsUrl()}?timestamp=${Date.now()}`,
      );
    }
  }, [showRecommendations]);

  useEffect(() => {
    if (retailerSettingsService.productRecommendationsEnabled()) {
      attachProductRecListeners({ onChange: handleChange });
    }
  }, []);

  return (
    <div
      className={classnames('product-recommendations-outer-container', s.outer_container)}
      style={{ display: showRecommendations ? 'block' : 'none' }}
    >
      <div className={classnames('container product-recommendations-container', s.container)}>
        <iframe
          id="product-recommendations-iframe"
          className={s.sandbox}
          style={{ display: showRecommendations ? 'block' : 'none' }}
          src={recommendationsUrl}
          sandbox="allow-popups allow-scripts allow-same-origin allow-forms"
          scrolling="no"
        />
      </div>
    </div>
  );
};
